// Shared formatting utilities
export const toTitleCase = (str) => {
  if (!str) return '';
  return str.toLowerCase().replace(/\b\w/g, c => c.toUpperCase());
};

export const fmt = (val) => Math.round(parseFloat(val || 0)).toLocaleString('en-IN');
export const fmtRound = (val) => Math.round(parseFloat(val || 0)).toLocaleString('en-IN');
